module.exports = __webpack_public_path__ + "images/94cafb0d1b4a2875215db17964f0938a.svg";